<template>
  <v-row>
    <!-- chart -->
    <v-col class="col-12">
      <chartjs-wrapper
        ref="chartJsWrapper"
        class="white"
        chartId="dailyBaseRateChart"
        :chart-data="dailyBaseRateChartData"
        :type="'line'"
        :options="dailyBaseRateChartOptions"
        :chart-height="20"
        hover-line
        @click:element="clickedChartPoint"
      >
      </chartjs-wrapper>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DateRangeChartMixin from '@/components-internal/mixins/DateRangeChartMixin.js'
import Products from '@/classes-shared/products/Products'
import _ from 'lodash'
import definitions from '../../../definitions'

export default Vue.extend({
  name: 'DailyBaseRateChart',
  mixins: [DateRangeChartMixin],

  props: {
    products: {
      type: Products,
      required: true,
    },
    dailyBaseRates: {
      type: Array,
      required: true,
    },
  },

  computed: {
    dailyBaseRateChartData() {
      let data = {
        labels: [],
        datasets: [],
      }

      let linesData = _.groupBy(this.dailyBaseRates, 'productId')
      let colors = [...definitions.colors.lineChart]
      let color = definitions.colors.named.minPrice

      for (let productId in linesData) {
        let line = {
          lineTension: 0,
          data: [],
          /* global i18n */
          pointRadius: [],
          borderWidth: definitions.globalChartSettings.borderWidth,
          pointBackgroundColor: [],
          pointBorderColor: [],
          borderColor: color,
          backgroundColor: 'rgba(92, 179, 224, 0.2)',
          fill: true,
        }
        linesData[productId].forEach((baseRate) => {
          line.data.push(baseRate.currentBaseRate() / 100)
          if (baseRate.isOverwritten()) {
            line.pointBackgroundColor.push(definitions.colors.named.overwritten)
            line.pointBorderColor.push(definitions.colors.named.overwritten)
            line.pointRadius.push(definitions.globalChartSettings.pointRadius)
          } else {
            line.pointBackgroundColor.push('white')
            line.pointBorderColor.push(color)
            line.pointRadius.push(0)
          }

          if (data.labels.length <= linesData[productId].length) {
            data.labels.push(baseRate.date)
          }
        })
        data.datasets.push(line)
        color = colors.pop()
      }

      return data
    },
    dailyBaseRateChartOptions() {
      const mainOptions = {
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: (tooltipItems) => {
              return (
                this.$i18n.t('dailyBaseRateChart.overlayText') +
                ` ${store.getters
                  .getCurrentDestinationInstance()
                  .getCurrency()} ` +
                tooltipItems.yLabel
              )
            },
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString:
                  this.$t('dailyBaseRateChart.ylabel') +
                  ` ${store.getters
                    .getCurrentDestinationInstance()
                    .getCurrency()}`,
              },
              ticks: {
                fontColor: definitions.colors.named.minPrice,
              },
            },
          ],
        },
      }
      return _.merge(this.baseChartOptions, mainOptions)
    },
  },
})
</script>
